import { render } from "./LokSabha.vue?vue&type=template&id=42c9ecb1&scoped=true"
import script from "./LokSabha.vue?vue&type=script&lang=js"
export * from "./LokSabha.vue?vue&type=script&lang=js"

import "./LokSabha.vue?vue&type=style&index=0&id=42c9ecb1&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c9ecb1"]])

export default __exports__